export const en = {
  common: {
    loading: "Loading..."
  }
}